module.exports = __webpack_public_path__ + "media/bootstrap-icons/grid-fill-3374fdb2.svg";